import React, { useEffect } from "react";

import { Survey } from "@/components/survey/Survey";
import QuestionSets from "@/components/survey/questionSets/questionSets";
import { HideHeader } from "@/contexts";
import { useGoto, useTrackEvent } from "@/hooks";
import { getAutologinData } from "@/utils/cookies";

export const ConnectHealthRecordsView: React.FC = () => {
  const { openApp } = useGoto();
  const { linkB2BIdentity } = useTrackEvent();

  useEffect(() => {
    const autologinData = getAutologinData();
    if (autologinData) {
      const { accessCode } = autologinData;
      linkB2BIdentity(accessCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSurveyComplete = async () => {
    openApp();
  };

  return (
    <HideHeader>
      <Survey
        baseRoute="/connect-health-records"
        onSurveyComplete={onSurveyComplete}
        questionSet={QuestionSets.CONNECT_HEALTH_RECORDS_SURVEY}
        resetOnOpen={false}
      />
    </HideHeader>
  );
};
